import { FC, ReactElement } from 'react'

import { ConnectedInactiveUser } from '@/connectors'

export const InactiveUserPage: FC = (): ReactElement => (
    <ConnectedInactiveUser />
)
